import {
  commitMutation,
  graphql
} from 'react-relay';
import environment from '../Environment';

const mutation = graphql`
mutation DocumentsMutation($token: String!, $contractId: ID!) {
  documents(token: $token, contractId: $contractId) { 
    ok
    token
    status
    contractDescription {
      NC {
        bases {
          baseId
          documents {
            type
            url
            id
            label
          }
          options {
            optionId
            documents {
              type
              url
              id
              label
            }
          }
        }
      }
      APP {
        bases {
          baseId
          documents {
            type
            url
            id
            label
          }
          options {
            optionId
            documents {
              type
              url
              id
              label
            }
          }
        }
      }
      AM {
        bases {
          baseId
          documents {
            type
            url
            id
            label
          }
          options {
            optionId
            documents {
              type
              url
              id
              label
            }
          }
        }
      }
      C { 
        bases {
          baseId
          documents {
            type
            url
            id
            label
          }
          options {
            optionId
            documents {
              type
              url
              id
              label
            }
          }
        }
      }
      TOUS {
        bases {
          baseId
          documents {
            type
            url
            id
            label
          }
          options {
            optionId
            documents {
              type
              url
              id
              label
            }
          }
        }
      }
    }
  }
}
`;

export default ({ token, contractId }, done) => {
  const variables = {
    token,
    contractId
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      updater: () => {
      },
      optimisticUpdater: () => {
      },
      onCompleted: (response) => {
        const { ok, token, status, contractDescription, error } = response.documents;
        done(ok, token, status, contractDescription, error);
      },
      onError: err => console.error(err)
    }
  );
};
